var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcErrorDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47297 0 0 4.47254 0 10C0 15.5271 4.47254 20 10 20C15.527 20 20 15.5275 20 10C20 4.47293 15.5275 0 10 0ZM10 18.4375C5.33656 18.4375 1.5625 14.6638 1.5625 10C1.5625 5.33652 5.33621 1.5625 10 1.5625C14.6634 1.5625 18.4375 5.33621 18.4375 10C18.4375 14.6635 14.6638 18.4375 10 18.4375Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4214 12.3165L11.1049 10L13.4214 7.68353C13.7264 7.37846 13.7265 6.88381 13.4214 6.57869C13.1162 6.27357 12.6216 6.27361 12.3166 6.57869L10 8.89518L7.68352 6.57869C7.37848 6.27357 6.88375 6.27357 6.57867 6.57869C6.27359 6.88381 6.27359 7.37846 6.57871 7.68353L8.8952 10L6.57871 12.3165C6.27359 12.6216 6.27355 13.1163 6.57867 13.4213C6.88387 13.7265 7.37852 13.7264 7.68352 13.4213L10 11.1049L12.3166 13.4213C12.6216 13.7264 13.1163 13.7265 13.4214 13.4213C13.7265 13.1162 13.7265 12.6216 13.4214 12.3165Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorDarkMode);
export default __webpack_public_path__ + "static/media/ic-error-dark-mode.f1439d9a4b6f236ac9cc7dddff661da7.svg";
export { ForwardRef as ReactComponent };